import dayjs, { Dayjs } from 'dayjs'
import { TIMEZONE_PST } from 'helpers/datetime'
import { ReportSourceKey } from '../../api/reconciliation-v2-reports-api-client'
import {
  formatMoney,
  SOURCE_LABELS,
} from '../../components/TransactionDetails/helpers'

/** Label for unpaid benefits with no recognizable assigned payment method. */
export const BLANK_SOURCE_LABEL = '(blank)'

/** Current month in LA, as a first-of-month Dayjs. */
export const currentMonthLA = (): Dayjs =>
  dayjs(dayjs().tz(TIMEZONE_PST).format('YYYY-MM-01'))

/** Column order of the annual tables — matches Finance's spreadsheet. */
export const ANNUAL_SOURCE_COLUMNS: readonly ReportSourceKey[] = [
  ReportSourceKey.Marqeta,
  ReportSourceKey.Wex,
  ReportSourceKey.IStream,
  ReportSourceKey.Check,
  ReportSourceKey.GroupAch,
  ReportSourceKey.EePaid,
  ReportSourceKey.Blank,
]

/** Always shown; the rest only when they carry money in that table. */
export const CORE_SOURCE_COLUMNS: ReadonlySet<ReportSourceKey> =
  new Set<ReportSourceKey>([
    ReportSourceKey.Marqeta,
    ReportSourceKey.Wex,
    ReportSourceKey.IStream,
    ReportSourceKey.Check,
    ReportSourceKey.GroupAch,
  ])

export const reportSourceLabel = (key: ReportSourceKey): string =>
  key === ReportSourceKey.Blank ? 'Blank' : (SOURCE_LABELS[key] ?? key)

/** Spreadsheet-style money: a dash for zero. */
export const formatReportMoney = (value: number): string =>
  value === 0 ? '–' : formatMoney(value)
